export class CompareNumber {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get comparer() {
        return this.parent;
    }
    get matchesNumberValue() {
        return parseInt(this.comparer.userInput) === parseInt(this.comparer.cleanedExpectedInput);
    }
}
